import { defaultLanguages } from '$lib/data/defaultLanguages';
import languagesData from '$lib/data/generated/content/settings/languages/data.json';
import { get } from 'svelte/store';
import { store } from './store';

export const translate = (key, lang) => {
	let translation;
	if (lang && key?.translations?.[lang]) {
		translation = key?.translations?.[lang] || 'no translation available';
	} else {
		translation = key?.value || '';
	}
	return (translation || '').replace(/\+\:\+/g, ':');
};

export const getSupportedLanguagesAry = () => {
	const currentStore = get(store);
	const storeLanguageDocs = { ...currentStore?.settings?.docs?.languages };
	const contentLanguageDocs = { ...languagesData };

	// const languageDocs = { ...storeLanguageDocs, ...contentLanguageDocs };
	const languageDocs = { ...contentLanguageDocs, ...storeLanguageDocs };

	// get the language key from the data and/or content...
	const dataContentDefaultLanguageKeys = Object.keys(languageDocs || {}).filter(key => !!languageDocs[key]?.value?.code?.value && languageDocs[key]?.value?.default?.value === 'true');

	// only put the system defaultLanguages in the mix if there is no default language key in the data and/or content
	const languages = { ...languageDocs, ...(dataContentDefaultLanguageKeys.length > 0 ? {} : defaultLanguages) };

	const supportedLanguagesAry = Object.keys(languages)
		.sort()
		.map(
			(slkey) => languages[slkey]?.value
		)
		.filter((language) => !!language?.code);

	const defaultLanguageCode = supportedLanguagesAry
		.find((l) => (l.default?.value === 'true' ? true : false))
		.code.value;

	const supportedLanguageAry = supportedLanguagesAry.map(
		(l) => l.code.value
	);

	return {
		supportedLanguagesAry,
		supportedLanguageAry,
		defaultLanguageCode,
	};

};
